module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/store_images/3_4f2fc4646206a625825cf6aa2c03bc40.png";